import { Wind } from 'lucide-react'
import { SeriesChart, VitalChartFrame, vitalNumber } from '../VitalPlot/VitalPlot'
import '../VitalPlot/VitalPlot.css'
import './OximetryChart.css'

function formatSpo2(value) {
  if (!Number.isFinite(value)) return '—'
  const rounded = Math.round(value * 10) / 10
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}%`
}

function OximetryChart({ points = [] }) {
  const series = points
    .map((point) => ({ at: point.at, value: vitalNumber(point.oxygen) }))
    .filter((point) => point.value != null)
    .map((point) => ({ at: point.at, value: point.value, label: formatSpo2(point.value) }))
  const latest = series.length ? series[series.length - 1].value : null
  const values = series.map((point) => point.value)
  const dataMin = values.length ? Math.min(...values) : 95
  const yMin = Math.min(85, Math.floor(dataMin / 5) * 5)
  const yMax = 100
  const ticks = []
  for (let tick = yMin; tick <= yMax; tick += 5) ticks.push(tick)

  return (
    <VitalChartFrame
      className="oximetry-chart"
      icon={<Wind size={16} />}
      title="Monitoramento de Oximetria & SpO2 (%)"
      badgeLabel="SpO2 Atual:"
      badgeValue={formatSpo2(latest)}
      legend={[
        { mark: 'is-alert', label: 'Hipóxia (< 90%)' },
        { mark: 'is-safe', label: 'Faixa alvo (95 - 100%)' }
      ]}
      empty={series.length === 0 ? 'Nenhuma oximetria registrada para este paciente.' : ''}
    >
      <SeriesChart
        points={series}
        yMin={yMin}
        yMax={yMax}
        ticks={ticks}
        tickLabel={(tick) => `${tick}%`}
        band={{ from: 95, to: 100 }}
        guides={[
          { key: 'target', value: 95, className: 'vital-guide-safe' },
          { key: 'hypoxia', value: 90, className: 'vital-guide-alert' }
        ]}
        gradientFrom="#0891b2"
        gradientTo="#cffafe"
        ariaLabel="Monitoramento de oximetria e SpO2"
      />
    </VitalChartFrame>
  )
}

export default OximetryChart
